import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { TostMsg } from "../../../App";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import moment from "moment";
import {
  DeleteDocument,
  FolderDocumentContains,
  FolderDocumentUpdate,
  FolderMarkAsFav,
  makeDocumentPinn,
  moveFolderData,
  uploadDocFile,
  versionHistoryListData,
} from "./DocumentService";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { debounce } from "lodash";
import CreateFolder from "./CreateFolder";
import MoveFolder from "./MoveFolder";
import ErrorMessagePopup from "./ErrorMessagePopup";
import DocumentDragDrop from "./DragDrop";
import documentConfig from "../../../config/documentConfig";
import UploadFile_KEYS from "../../../Services/Global-Services/UploadFile_Keys";

const DocumentFile = () => {
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [documentContent, setDocumentContent] = useState("");
  const [documentHeading, setDocumentHeading] = useState("");
  const toster = useContext(TostMsg);
  const [Isloading, setIsloading] = useState(false);
  const [allFolderData, setAllFolderData] = useState([]);
  const [importantFolderData, setImportantForlderData] = useState([]);
  const [documentManage, setDocumentManage] = useState(false);
  const [documentPinned, setDocumentPinned] = useState(false);
  const [documentUpload, setDocumentUpload] = useState(false);
  const [documentRead, setDocumentRead] = useState(false);
  let history = useHistory();
  const [documentId, setSelectedDeleteDocumentId] = useState(0);
  const [selecteddocumentId, setDocumentId] = useState(0);
  const [renameFolder, setRenameFolder] = useState([]);
  const [docName, setDocName] = useState("");
  const [versionHistoryData, setVersionHistoryData] = useState([]);
  const [auditLogData, setAuditLogData] = useState([]);
  const [masterFolderAllData, setMasterFolderAllData] = useState([]);
  const [renameValidation, setRenameValidation] = useState(false);
  const [errorMessagePopup, setErrorMessagePopup] = useState(false);
  const [errorMessages, setErrorMessage] = useState("");
  const [renameErrorMessage, setRenameErrorMessage] = useState(true);
  const [deleteErrorMessage, setDeleteConfirmErrorMessage] = useState(false);
  const [isOver, setIsOver] = useState(false);
  const defaultImage = "/images/placeholder_profile.png";
  const [dropInFolderError, setDropInFolderMessage] = useState("");
  const [folderData, setFolderData] = useState({});
  const fileTypes = documentConfig;
  const [resetKey, setResetKey] = useState(0);
  const [isBookmarkedValue, setIsBookMarkedValue] = useState(0);

  useEffect(() => {
    GetMasterSystemAlertList();

    getFolderData("");
    permissionAccouncementList();
    if (localStorage.removeItem("breadcrumbs")) {
      localStorage.removeItem("breadcrumbs");
    }
  }, []);

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (
        UserPermission.PermissionName == "Document.Manage" &&
        UserPermission.IsGranted == true
      ) {
        setDocumentManage(true);
      }

      if (
        UserPermission.PermissionName == "Document.Pin" &&
        UserPermission.IsGranted == true
      ) {
        setDocumentPinned(true);
      }

      if (
        UserPermission.PermissionName == "Document.Upload" &&
        UserPermission.IsGranted == true
      ) {
        setDocumentUpload(true);
      }

      if (
        UserPermission.PermissionName == "Document.Read" &&
        UserPermission.IsGranted == true
      ) {
        setDocumentRead(true);
      }
    });
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      }
      if (msg?.Name == "Document_Heading") {
        setDocumentHeading(msg?.Desc);
      }
      if (msg?.Name == "Document_Center") setDocumentContent(msg?.Desc);
    });
  }, []);

  async function getFolderData(searchValue) {
    setIsloading(true);
    const req = {
      Empid: userDetails?.EmpId,
      Type: 0,
      LabelId: 0,
      Search: searchValue ? searchValue : "",
      Id: 0,
      GUID: "",
      BookMarkedOnly: isBookmarkedValue,
    };
    try {
      const responseData = await FolderDocumentContains(req);
      const data =
        responseData?.Data.map((folder) => ({
          ...folder,
          isDraggingDropping: false,
        })) || [];

      setMasterFolderAllData(data);

      const ImpData = data ? data.filter((item) => item.IsPinned === true) : [];

      setAllFolderData(data);
      setImportantForlderData(ImpData);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.GetFolder);
    }
  }

  const makeUnPin = async (FolderId, value, docTypeId) => {
    const params = {
      OrgId: userDetails?.OrgId,
      LabelId: FolderId,
    };
    try {
      setIsloading(true);
      const responseData = await makeDocumentPinn(params);
      if (value === false) {
        if (docTypeId === 101) {
          GetMasterSystemAlertList("Folder_Pinned", 0);
        } else {
          GetMasterSystemAlertList("Doc_Pinned", 0);
        }
      } else {
        if (docTypeId === 101) {
          GetMasterSystemAlertList("Folder_Unpinned", 0);
        } else {
          GetMasterSystemAlertList("Doc_Unpinned", 0);
        }
      }

      if (responseData) {
        await getFolderData("");
      }
    } catch (error) {
      toster.current.error(ERROR_LIST.MakeUnPin);
    } finally {
      setIsloading(false);
    }
  };

  const deleteDocumentConfirmation = (id) => {
    setSelectedDeleteDocumentId(id);
  };

  async function deleteDocument(isOverride) {
    setIsloading(true);
    const params = {
      Id: documentId,
      IsOverride: isOverride,
    };

    try {
      const response = await DeleteDocument(params);
      setIsloading(false);

      if (response.StatusCode === 2000) {
        GetMasterSystemAlertList("Doc_Delete", 0);
        await getFolderData("");

        setSelectedDeleteDocumentId(0);
      } else {
        setDeleteConfirmErrorMessage(response?.Message);
        const modalEl = document.getElementById("delete-doc-confirm");
        const modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      }
    } catch (error) {
      setIsloading(false);
    } finally {
      setIsloading(false);
    }
  }

  async function markAsFavourite(documentId) {
    setIsloading(true);
    const params = {
      DocId: documentId,
    };
    try {
      const response = await FolderMarkAsFav(params);
      if (response) {
        await getFolderData("");
        setIsloading(false);
      }
    } catch (error) {
      setIsloading(false);
      toster.current.error(ERROR_LIST.GetFolder);
    }
  }

  const handleSearchInputChange = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((value) => {
      if (value) {
        getFolderData(value);
      } else {
        getFolderData("");
      }
    }, 800),
    [importantFolderData, allFolderData],
  );

  const closeDocumentPopup = (value) => {
    if (value.close === true) {
      document.querySelector("#UploadDocumentFile .btn-close")?.click();

      if (value.success === 1) {
        getFolderData("");
      }
    }
  };

  const closeCreateFolderPopup = (value) => {
    if (value === true) {
      document.querySelector("#CreateFolder .btn-close")?.click();

      getFolderData("");
    }
  };

  const closeMoveFolderPopup = (value) => {
    if (value.close === true) {
      document.querySelector("#move-doc .btn-close")?.click();

      if (value.success === 1) {
        getFolderData("");
      }
    }
  };

  async function FolderRename() {
    let documentName = "";
    if (renameFolder?.DocTypeId === 101) {
      documentName = docName;
    } else {
      documentName = `${docName}${renameFolder?.DocName?.slice(
        renameFolder?.DocName?.lastIndexOf("."),
      )}`;
    }
    const params = {
      Id: renameFolder ? renameFolder?.Id : 0,
      LabelId: renameFolder ? Number(renameFolder?.LabelId) : 0,
      EmpId: userDetails?.EmpId,
      DocPath: renameFolder ? renameFolder?.DocPath : "",
      Name: documentName ? documentName : "",
      Desc: renameFolder?.DocDesc,
      DocTypeId: renameFolder?.DocTypeId,
      IsOverride: 0,
    };
    if (docName) {
      try {
        const response = await FolderDocumentUpdate(params);
        if (response?.StatusCode === 2000) {
          if (params?.DocTypeId === 101) {
            GetMasterSystemAlertList("Folder_Renamed", 0);
          } else {
            GetMasterSystemAlertList("Doc_Rename", 0);
          }

          setRenameFolder([]);
          setDocName("");
          getFolderData("");
          setRenameErrorMessage("");
          document.querySelector("#Rename .btn-close")?.click();
        } else {
          setRenameErrorMessage(response?.Message);
        }

        setIsloading(false);
      } catch (error) {
        toster.current.error(ERROR_LIST.PostFolder);
        setIsloading(false);
      }
    } else {
      setRenameValidation(true);
    }
  }

  async function versionHistoryList(documentId) {
    setIsloading(true);
    let req = {
      DocId: documentId,
    };

    try {
      const response = await versionHistoryListData(req);
      setVersionHistoryData(
        response?.Data.filter((item) => item?.IsVersion === 1),
      );
      setAuditLogData(response?.Data);
      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  const handleFavouriteChange = (e) => {
    const value = e.target.checked ? 1 : 0;
    setIsBookMarkedValue(value);
  };

  useEffect(() => {
    getFolderData("");
  }, [isBookmarkedValue]);

  const handleDragEnter = (e, folder) => {
    e.preventDefault();

    setAllFolderData((prev) =>
      prev.map((f) =>
        f.Id === folder?.Id ? { ...f, isDraggingDropping: false } : f,
      ),
    );

    setImportantForlderData((prev) =>
      prev.map((f) =>
        f.Id === folder?.Id ? { ...f, isDraggingDropping: false } : f,
      ),
    );
  };

  const handleDragLeave = (e, folder) => {
    e.preventDefault();

    setAllFolderData((prev) =>
      prev.map((f) =>
        f.Id === folder?.Id ? { ...f, isDraggingDropping: false } : f,
      ),
    );
    setImportantForlderData((prev) =>
      prev.map((f) =>
        f.Id === folder?.Id ? { ...f, isDraggingDropping: false } : f,
      ),
    );
  };

  const handleDragOver = (e, folder) => {
    e.preventDefault();

    setAllFolderData((prev) =>
      prev.map((f) => ({
        ...f,
        isDraggingDropping: f.Id === folder?.Id,
      })),
    );
    setImportantForlderData((prev) =>
      prev.map((f) => ({
        ...f,
        isDraggingDropping: f.Id === folder?.Id,
      })),
    );
  };

  const handleDrop = async (event, document) => {
    event.preventDefault();
    setAllFolderData((prev) =>
      prev.map((f) =>
        f.Id === document?.Id ? { ...f, isDraggingDropping: false } : f,
      ),
    );

    setImportantForlderData((prev) =>
      prev.map((f) =>
        f.Id === document?.Id ? { ...f, isDraggingDropping: false } : f,
      ),
    );

    if (event.dataTransfer.getData("files")) {
      const files = JSON.parse(event.dataTransfer.getData("files"));
      if (files?.Id === document.Id) {
        toster.current.error("Item can not be moved in same folder.");
      } else {
        if (files) {
          let req = {
            OrgId: userDetails?.OrgId,
            LabelId: document ? document.Id : 0,
            Id: files.Id,
            IsOverride: 0,
            LoggedInUserId: userDetails?.Id,
          };
          try {
            const responseData = await moveFolderData(req);
            getFolderData("");
            if (responseData?.StatusCode === 2000) {
              if (files?.DocTypeId === 101) {
                GetMasterSystemAlertList("Folder_move", 0);
              } else {
                GetMasterSystemAlertList("Doc_Move", 0);
              }
            } else if (responseData?.StatusCode === 2003) {
              closeMoveFolderPopup({ close: true, success: 0 });
              setErrorMessage({
                Message: responseData?.Message,
                FolderId: req.Id,
                SelectedFolderId: req.LabelId,
              });
            } else {
              toster.current.error(responseData?.Message);
            }
          } catch (error) {
            toster.current.error(error.error.Message);
          }
        }
      }
    } else {
      if (document.DocTypeId != 101) {
        toster.current.error("Item can not be moved in same folder.");
      } else {
        handleDropIntoFolder(event, document);
      }
    }
  };

  const handleDropIntoFolder = async (e, document) => {
    e.preventDefault();

    const items = e.dataTransfer.items;
    const allFiles = [];
    for (let i = 0; i < items.length; i++) {
      const entry = items[i].webkitGetAsEntry();
      if (entry) {
        const files = await traverseFileTree(entry);
        allFiles.push(files);
        await processDragDrop(files, document ? document?.Id : 0, 0, false);
      }
    }
    toster.current.success("Document uploaded successfully");
  };

  function traverseFileTree(item, path = "") {
    return new Promise((resolve) => {
      if (item.isFile) {
        item.file((file) => {
          resolve({
            name: file.name,
            type: "file",

            file,
          });
        });
      } else if (item.isDirectory) {
        const dirReader = item.createReader();

        dirReader.readEntries(async (entries) => {
          let results = [];
          for (let entry of entries) {
            const nestedFiles = await traverseFileTree(entry);

            results.push(nestedFiles);
          }

          resolve({
            name: item.name,
            type: "directory",
            DocTypeId: 101,
            results,
          });
        });
      }
    });
  }

  async function onDragDropFile({ folder, folderId, isOverride }) {
    const params = {
      Id: 0,
      LabelId: folderId ? Number(folderId) : 0,
      EmpId: userDetails?.EmpId,
      DocPath: folder?.docPath,
      Name: folder?.fileName,
      Desc: "",
      DocTypeId: folder?.docTypeId,
      IsOverride: isOverride ? isOverride : 0,
    };

    try {
      const response = await FolderDocumentUpdate(params);

      if (response?.StatusCode === 2000) {
        getFolderData("");
        setDropInFolderMessage("");
        setFolderData({});
      } else {
        setFolderData({ folder: folder, folderId: folderId, type: "file" });
        setDropInFolderMessage(response?.Message);
        const modalEl = document.getElementById("DropErrorMessagePopup");
        const modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      }

      setIsloading(false);
    } catch (error) {
      setIsloading(false);
    }
  }

  async function uploadFolderDocFile(file, folderId, isOverride) {
    setIsloading(true);

    if (file) {
      const formData = new FormData();

      formData.append("files", file);

      let params = {
        UploadType: UploadFile_KEYS?.Document,
        RefId: 0,
      };

      try {
        const response = await uploadDocFile(params, formData);

        const docPathURL = response?.Data;

        const docPath = docPathURL[0];
        const fileName = docPath.split(/[/\\]/).pop();
        const ext = fileName.split(".").pop();
        let docTypeId = 0;
        if (["jpeg", "jpg", "png"].includes(ext)) docTypeId = 106;
        else if (ext === "pdf") docTypeId = 102;
        else if (["xls", "xlsx", "csv"].includes(ext)) docTypeId = 103;
        else if (["doc", "docx"].includes(ext)) docTypeId = 104;
        else if (["ppt", "pptx"].includes(ext)) docTypeId = 105;
        else if (ext === "mp4") docTypeId = 107;
        else if (ext === "mp3") docTypeId = 108;
        else if (["zip", "rar"].includes(ext)) docTypeId = 109;
        else docTypeId = 110;

        await onDragDropFile({
          folder: {
            docPath: docPath,
            fileName: fileName,
            docTypeId: docTypeId,
          },

          folderId,
          isOverride,
        });

        setIsloading(false);
      } catch (error) {
        setIsloading(false);
      } finally {
      }
    } else {
      setIsloading(false);
    }
  }

  async function onDragDropFolder(folder, folderId) {
    const params = {
      Id: 0,
      LabelId: folderId ? Number(folderId) : 0,
      EmpId: userDetails?.EmpId,
      DocPath: "",
      Name: folder?.name,
      Desc: "",
      DocTypeId: folder?.DocTypeId,
      IsOverride: folder?.IsOverride || 0,
    };

    try {
      const response = await FolderDocumentUpdate(params);

      if (response?.StatusCode === 2000) {
        getFolderData("");
        setDropInFolderMessage("");
        setFolderData({});
      } else if (response?.StatusCode === 2003) {
        setFolderData({ folder: folder, folderId: folderId, type: "folder" });
        setDropInFolderMessage(response?.Message);

        const modalEl = document.getElementById("DropErrorMessagePopup");
        const modal = new window.bootstrap.Modal(modalEl);
        modal.show();
      }

      return response;
    } catch (error) {}
  }

  async function processDragDrop(
    folder,
    folderId,
    isOverride = 0,
    isRootOverride = false,
  ) {
    try {
      if (folder.type === "file" && isOverride === 0) {
        await uploadFolderDocFile(folder.file, folderId, isOverride);
      } else {
        await onDragDropFile({ folder: folder, folderId, isOverride });
      }

      if (folder.type === "directory") {
        const response = await onDragDropFolder(
          { ...folder, IsOverride: isOverride },
          folderId,
        );
        if (response?.StatusCode === 2000) {
          for (const child of folder.results) {
            await processDragDrop(child, response?.Data?.Id, 0, false);
          }

          if (isRootOverride) {
            isOverride = 0;
          }
        }
      }
    } catch (error) {}
  }

  const navigateFolderPage = (folder) => {
    sessionStorage.setItem("reload", "true");
    history.push(`/DocumentList/${folder?.GUID}`);
  };

  const navigateFilePage = (folderId) => {
    history.push(`/Document/View/${folderId}`);
  };

  const dropFileFolder = (value) => {
    if (value.close === true && value.success === 1) {
      getFolderData("");
    }
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const setRenameDocValue = () => {
    if (renameFolder?.DocTypeId === 101) {
      return docName;
    } else {
      const dotIndex = docName.lastIndexOf(".");
      return dotIndex !== -1 ? docName.slice(0, dotIndex) : docName;
    }
  };

  return (
    <div>
      <div className="container-fluid   position-relative">
        <div className="row team-directories g-3">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center justify-content-between documentory-bx">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">{documentHeading}</h2>
                <p className="mb-0">{documentContent}</p>
              </div>
              <div className="rightside-tabs">
                <div className="d-flex align-items-center">
                  <div className="form-check form-switch me-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckChecked"
                      onChange={handleFavouriteChange}
                    />
                    <label
                      className="form-check-label fs-7 ms-0 mb-0"
                      for="flexSwitchCheckChecked"
                    >
                      Favourites
                    </label>
                  </div>

                  <div className="">
                    <div className="actionbutton-tickets document-search">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search Files & Folder"
                        onChange={handleSearchInputChange}
                      />
                    </div>
                  </div>

                  {documentUpload && (
                    <div className="dropdown documents-dropdown">
                      <button
                        className="add-newticket ms-0"
                        type="button"
                        id="dropdownMenuButton1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          className="bi bi-plus"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                        </svg>
                      </button>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <a
                            class="dropdown-item c-pointer"
                            data-bs-toggle="modal"
                            data-bs-target="#CreateFolder"
                          >
                            New Folder
                          </a>
                        </li>

                        <li>
                          <Link
                            to="/BulkUploadDocument/''"
                            className="dropdown-item c-pointer"
                          >
                            Upload files
                          </Link>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="page-content-inner all-projects mt-0 ">
              <div className="row justify-content-center">
                {documentUpload && (
                  <DocumentDragDrop
                    FolderId={0}
                    onDropFolder={(value) => dropFileFolder(value)}
                    errorMessage={(value) => {
                      setErrorMessage(value);
                    }}
                  />
                )}

                <div className="col-lg-12">
                  {importantFolderData?.length > 0 && (
                    <div className=" document-area">
                      <h3 className="top-title">Importants</h3>

                      <div className="files-block-area">
                        {importantFolderData?.map((folder, index) => (
                          <div
                            key={index}
                            className={
                              folder?.DocTypeId === 101
                                ? `document-file-box ${
                                    folder?.isDraggingDropping
                                      ? "drag-folder-active"
                                      : ""
                                  }`
                                : `files-all-block ${
                                    folder?.isDraggingDropping
                                      ? "drag-folder-active"
                                      : ""
                                  }`
                            }
                            onDragLeave={(e) => handleDragLeave(e, folder)}
                            onDragOver={(e) => handleDragOver(e, folder)}
                            onDrop={(e) => handleDrop(e, folder)}
                            onClick={(e) => e.preventDefault()}
                          >
                            <div className="sub-files-folder-area">
                              {folder?.DocTypeId !== 101 ? (
                                <div
                                  className="folder-box c-pointer"
                                  onClick={() => {
                                    if (folder?.DocTypeId === 102) {
                                      navigateFilePage(folder?.GUID);
                                    } else {
                                      window.open(folder.DocPath, "_blank");
                                    }
                                  }}
                                >
                                  <img
                                    src={
                                      fileTypes.find(
                                        (f) =>
                                          f.ext ===
                                          folder?.DocPath?.split(/[/\\]/)
                                            .pop()
                                            .split(".")
                                            .pop()
                                            .toLowerCase(),
                                      )?.icon ||
                                      "/images/document/otherFileIcon.png"
                                    }
                                    className="img-fluid"
                                  />
                                </div>
                              ) : (
                                <div
                                  className="folder-box c-pointer"
                                  onClick={() => {
                                    navigateFolderPage(folder);
                                  }}
                                >
                                  <img
                                    src="/images/document/folder-4.png"
                                    className="img-fluid"
                                  />
                                  <div className="item-fd">
                                    <span>{folder?.DocCount}</span>
                                  </div>
                                </div>
                              )}

                              <div className="content-area">
                                <div
                                  className="c-pointer"
                                  onClick={() => {
                                    if (folder?.DocTypeId === 101) {
                                      navigateFolderPage(folder);
                                    } else if (folder?.DocTypeId === 102) {
                                      navigateFilePage(folder?.GUID);
                                    } else {
                                      window.open(folder.DocPath, "_blank");
                                    }
                                  }}
                                >
                                  <h5 title={folder?.DocName}>
                                    {folder?.DocName?.slice(0, 15)}
                                    {folder?.DocName?.length > 15 && (
                                      <span>...</span>
                                    )}{" "}
                                  </h5>
                                  <p>
                                    {" "}
                                    {moment(folder?.CreatedDate).format(
                                      "MMM DD YYYY",
                                    )}{" "}
                                  </p>
                                </div>
                                <div className="d-flex justify-content-end align-items-center">
                                  <div className="d-flex align-items-center favourite-icon">
                                    <div className="document-hover">
                                      {folder?.IsBookMarkedByMe === 0 ? (
                                        <a
                                          className="like-button me-2"
                                          onClick={() =>
                                            markAsFavourite(folder?.Id)
                                          }
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="13"
                                            height="13"
                                            fill="currentColor"
                                            className="bi bi-heart"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
                                          </svg>
                                        </a>
                                      ) : (
                                        <button
                                          className="btn p-0 me-2"
                                          type="button"
                                          style={{ color: "red" }}
                                          onClick={() =>
                                            markAsFavourite(folder?.Id)
                                          }
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="13"
                                            height="13"
                                            fill="currentColor"
                                            className="bi bi-heart-fill"
                                            viewBox="0 0 16 16"
                                          >
                                            <path
                                              fill-rule="evenodd"
                                              d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
                                            />
                                          </svg>
                                        </button>
                                      )}

                                      {documentManage &&
                                        folder?.IsEdit === 1 && (
                                          <a
                                            className="c-pointer me-1"
                                            draggable
                                            onDragStart={(e) => {
                                              e.dataTransfer.setData(
                                                "files",
                                                JSON.stringify(folder),
                                              );
                                            }}
                                            onDragEnter={(e) =>
                                              handleDragEnter(e, folder)
                                            }
                                            onDragLeave={(e) =>
                                              handleDragLeave(e, folder)
                                            }
                                            onDragOver={(e) =>
                                              handleDragOver(e, folder)
                                            }
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="13"
                                              height="13"
                                              fill="currentColor"
                                              class="bi bi-arrows-move"
                                              viewBox="0 0 16 16"
                                            >
                                              <path
                                                fill-rule="evenodd"
                                                d="M7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10M.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708zM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8"
                                              />
                                            </svg>
                                          </a>
                                        )}
                                      <div class="dropdown documents-dropdown text-dark">
                                        <button
                                          className="btn-link bg-transparent p-0 text-dark"
                                          type="button"
                                          id="user-edit-drop"
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="13"
                                            height="13"
                                            fill="currentColor"
                                            class="bi bi-three-dots-vertical"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                          </svg>
                                        </button>
                                        <ul
                                          class="dropdown-menu"
                                          aria-labelledby="user-edit-drop"
                                        >
                                          {documentPinned && (
                                            <li>
                                              <a
                                                class="dropdown-item c-pointer"
                                                onClick={() =>
                                                  makeUnPin(
                                                    folder?.Id,
                                                    folder?.IsPinned,
                                                    folder?.DocTypeId,
                                                  )
                                                }
                                              >
                                                {folder?.IsPinned === true ? (
                                                  <>
                                                    <img
                                                      src="/images/document/important-icon.png"
                                                      className="document-dropdown-icon"
                                                    />{" "}
                                                    <span>Unpin</span>
                                                  </>
                                                ) : (
                                                  <>
                                                    <img
                                                      src="/images/document/unimportant-icon.png"
                                                      className="document-dropdown-icon"
                                                    />{" "}
                                                    <span>Pin to top</span>
                                                  </>
                                                )}
                                              </a>
                                            </li>
                                          )}
                                          {documentManage &&
                                            folder?.IsEdit === 1 && (
                                              <>
                                                <li>
                                                  <a
                                                    class="dropdown-item c-pointer"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#Rename"
                                                    onClick={() => {
                                                      setRenameFolder(folder);
                                                      setDocName(
                                                        folder?.DocName,
                                                      );
                                                    }}
                                                  >
                                                    <img
                                                      src="/images/document/edit-icon.png"
                                                      className="document-dropdown-icon"
                                                    />{" "}
                                                    <span>Rename</span>
                                                  </a>
                                                </li>

                                                <li>
                                                  <a
                                                    data-bs-target="#move-doc"
                                                    data-bs-toggle="modal"
                                                    className="dropdown-item c-pointer"
                                                    onClick={() =>
                                                      setDocumentId(folder?.Id)
                                                    }
                                                  >
                                                    <img
                                                      src="/images/document/move-icon.png"
                                                      className="document-dropdown-icon"
                                                    />{" "}
                                                    <span>Move to</span>
                                                  </a>
                                                </li>
                                              </>
                                            )}

                                          {folder?.DocTypeId !== 101 && (
                                            <li>
                                              <a
                                                onClick={() =>
                                                  versionHistoryList(folder?.Id)
                                                }
                                                data-bs-target="#version_history"
                                                data-bs-toggle="modal"
                                                className="dropdown-item c-pointer"
                                              >
                                                <img
                                                  src="/images/document/version history.png"
                                                  className="document-dropdown-icon"
                                                />{" "}
                                                <span> Version History</span>
                                              </a>
                                            </li>
                                          )}

                                          <li>
                                            <a
                                              onClick={() =>
                                                versionHistoryList(folder?.Id)
                                              }
                                              data-bs-target="#audit_log"
                                              data-bs-toggle="modal"
                                              className="dropdown-item c-pointer"
                                            >
                                              <img
                                                src="/images/document/audit logs.png"
                                                className="document-dropdown-icon"
                                              />{" "}
                                              <span>Audit Logs</span>
                                            </a>
                                          </li>

                                          {documentManage &&
                                            folder?.IsEdit === 1 && (
                                              <li>
                                                <a
                                                  data-bs-target="#delete-doc"
                                                  data-bs-toggle="modal"
                                                  className="dropdown-item c-pointer"
                                                  onClick={() =>
                                                    deleteDocumentConfirmation(
                                                      folder?.Id,
                                                    )
                                                  }
                                                >
                                                  <img
                                                    src="/images/document/delete-icon.png"
                                                    className="document-dropdown-icon"
                                                  />{" "}
                                                  <span>Delete</span>
                                                </a>
                                              </li>
                                            )}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-lg-12">
                  {allFolderData?.length > 0 && (
                    <div className=" document-area">
                      <h3 className="top-title">All</h3>
                      <div className="files-block-area">
                        {allFolderData?.map((folder, index) => (
                          <div
                            className={
                              folder?.DocTypeId === 101
                                ? `document-file-box ${
                                    folder?.isDraggingDropping
                                      ? "drag-folder-active"
                                      : ""
                                  }`
                                : `files-all-block ${
                                    folder?.isDraggingDropping
                                      ? "drag-folder-active"
                                      : ""
                                  }`
                            }
                            onDragLeave={(e) => handleDragLeave(e, folder)}
                            onDragOver={(e) => handleDragOver(e, folder)}
                            onDrop={(e) => handleDrop(e, folder)}
                            onClick={(e) => e.preventDefault()}
                          >
                            <div className="sub-files-folder-area" key={index}>
                              {folder?.DocTypeId !== 101 ? (
                                <div
                                  className="folder-box c-pointer"
                                  onClick={() => {
                                    if (folder?.DocTypeId === 102) {
                                      navigateFilePage(folder?.GUID);
                                    } else {
                                      window.open(folder.DocPath, "_blank");
                                    }
                                  }}
                                >
                                  <img
                                    src={
                                      fileTypes.find(
                                        (f) =>
                                          f.ext ===
                                          folder?.DocPath?.split(/[/\\]/)
                                            .pop()
                                            .split(".")
                                            .pop()
                                            .toLowerCase(),
                                      )?.icon ||
                                      "/images/document/otherFileIcon.png"
                                    }
                                    className="img-fluid"
                                  />
                                </div>
                              ) : (
                                <div
                                  className="folder-box c-pointer"
                                  onClick={() => {
                                    navigateFolderPage(folder);
                                  }}
                                >
                                  <img
                                    src="/images/document/folder-4.png"
                                    className="img-fluid"
                                  />
                                  <div className="item-fd">
                                    <span>{folder?.DocCount}</span>
                                  </div>
                                </div>
                              )}
                              <div className="content-area">
                                <div
                                  className="c-pointer"
                                  onClick={() => {
                                    if (folder?.DocTypeId === 101) {
                                      navigateFolderPage(folder);
                                    } else if (folder?.DocTypeId === 102) {
                                      navigateFilePage(folder?.GUID);
                                    } else {
                                      window.open(folder.DocPath, "_blank");
                                    }
                                  }}
                                >
                                  <h5 title={folder?.DocName}>
                                    {folder?.DocName.slice(0, 15)}
                                    {folder?.DocName?.length > 15 && (
                                      <span>...</span>
                                    )}
                                  </h5>
                                  <p>
                                    {" "}
                                    {moment(folder?.CreatedDate).format(
                                      "MMM DD YYYY",
                                    )}{" "}
                                  </p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="d-flex align-items-center favourite-icon"></div>
                                  <div className="document-hover">
                                    {folder?.IsBookMarkedByMe === 0 ? (
                                      <a
                                        className="like-button me-2"
                                        onClick={() =>
                                          markAsFavourite(folder?.Id)
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="13"
                                          height="13"
                                          fill="currentColor"
                                          className="bi bi-heart"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15" />
                                        </svg>
                                      </a>
                                    ) : (
                                      <button
                                        className="btn p-0 me-2"
                                        type="button"
                                        style={{ color: "red" }}
                                        onClick={() =>
                                          markAsFavourite(folder?.Id)
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="13"
                                          height="13"
                                          fill="currentColor"
                                          className="bi bi-heart-fill"
                                          viewBox="0 0 16 16"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
                                          />
                                        </svg>
                                      </button>
                                    )}

                                    {documentManage && folder?.IsEdit === 1 && (
                                      <a
                                        className="c-pointer me-1"
                                        draggable
                                        onDragStart={(e) => {
                                          e.dataTransfer.setData(
                                            "files",
                                            JSON.stringify(folder),
                                          );
                                        }}
                                        onDragEnter={(e) =>
                                          handleDragEnter(e, folder)
                                        }
                                        onDragLeave={(e) =>
                                          handleDragLeave(e, folder)
                                        }
                                        onDragOver={(e) =>
                                          handleDragOver(e, folder)
                                        }
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="13"
                                          height="13"
                                          fill="currentColor"
                                          class="bi bi-arrows-move"
                                          viewBox="0 0 16 16"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            d="M7.646.146a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 1.707V5.5a.5.5 0 0 1-1 0V1.707L6.354 2.854a.5.5 0 1 1-.708-.708zM8 10a.5.5 0 0 1 .5.5v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 14.293V10.5A.5.5 0 0 1 8 10M.146 8.354a.5.5 0 0 1 0-.708l2-2a.5.5 0 1 1 .708.708L1.707 7.5H5.5a.5.5 0 0 1 0 1H1.707l1.147 1.146a.5.5 0 0 1-.708.708zM10 8a.5.5 0 0 1 .5-.5h3.793l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L14.293 8.5H10.5A.5.5 0 0 1 10 8"
                                          />
                                        </svg>
                                      </a>
                                    )}
                                    <div class="dropdown documents-dropdown text-dark">
                                      <button
                                        className="btn-link bg-transparent p-0 text-dark btn"
                                        type="button"
                                        id="user-edit-drop"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="13"
                                          height="13"
                                          fill="currentColor"
                                          class="bi bi-three-dots-vertical"
                                          viewBox="0 0 16 16"
                                        >
                                          <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                        </svg>
                                      </button>
                                      <ul
                                        class="dropdown-menu"
                                        aria-labelledby="user-edit-drop"
                                      >
                                        {documentPinned && (
                                          <li>
                                            <a
                                              class="dropdown-item c-pointer"
                                              onClick={() =>
                                                makeUnPin(
                                                  folder?.Id,
                                                  folder?.IsPinned,
                                                  folder?.DocTypeId,
                                                )
                                              }
                                            >
                                              {folder?.IsPinned === true ? (
                                                <>
                                                  {" "}
                                                  <img
                                                    src="/images/document/important-icon.png"
                                                    className="document-dropdown-icon"
                                                  />{" "}
                                                  <span>Unpin</span>
                                                </>
                                              ) : (
                                                <>
                                                  {" "}
                                                  <img
                                                    src="/images/document/unimportant-icon.png"
                                                    className="document-dropdown-icon"
                                                  />{" "}
                                                  <span>Pin to top</span>
                                                </>
                                              )}
                                            </a>
                                          </li>
                                        )}
                                        {documentManage &&
                                          folder?.IsEdit === 1 && (
                                            <>
                                              <li>
                                                <a
                                                  class="dropdown-item c-pointer"
                                                  data-bs-toggle="modal"
                                                  data-bs-target="#Rename"
                                                  onClick={() => {
                                                    setRenameFolder(folder);
                                                    setDocName(folder?.DocName);
                                                  }}
                                                >
                                                  <img
                                                    src="/images/document/edit-icon.png"
                                                    className="document-dropdown-icon"
                                                  />{" "}
                                                  <span>Rename</span>
                                                </a>
                                              </li>

                                              <li>
                                                <a
                                                  data-bs-target="#move-doc"
                                                  data-bs-toggle="modal"
                                                  className="dropdown-item c-pointer"
                                                  onClick={() =>
                                                    setDocumentId(folder?.Id)
                                                  }
                                                >
                                                  <img
                                                    src="/images/document/move-icon.png"
                                                    className="document-dropdown-icon"
                                                  />{" "}
                                                  <span>Move to</span>
                                                </a>
                                              </li>
                                            </>
                                          )}

                                        {folder?.DocTypeId !== 101 && (
                                          <li>
                                            <a
                                              onClick={() =>
                                                versionHistoryList(folder?.Id)
                                              }
                                              data-bs-target="#version_history"
                                              data-bs-toggle="modal"
                                              className="dropdown-item c-pointer"
                                            >
                                              <img
                                                src="/images/document/version history.png"
                                                className="document-dropdown-icon"
                                              />{" "}
                                              <span>Version History</span>
                                            </a>
                                          </li>
                                        )}

                                        <li>
                                          <a
                                            onClick={() =>
                                              versionHistoryList(folder?.Id)
                                            }
                                            data-bs-target="#audit_log"
                                            data-bs-toggle="modal"
                                            className="dropdown-item c-pointer"
                                          >
                                            <img
                                              src="/images/document/audit logs.png"
                                              className="document-dropdown-icon"
                                            />{" "}
                                            <span>Audit Logs</span>
                                          </a>
                                        </li>

                                        {documentManage &&
                                          folder?.ModifiedBy ===
                                            userDetails?.EmpId && (
                                            <li>
                                              <a
                                                data-bs-target="#delete-doc"
                                                data-bs-toggle="modal"
                                                className="dropdown-item c-pointer"
                                                onClick={() =>
                                                  deleteDocumentConfirmation(
                                                    folder?.Id,
                                                  )
                                                }
                                              >
                                                <img
                                                  src="/images/document/delete-icon.png"
                                                  className="document-dropdown-icon"
                                                />{" "}
                                                <span>Delete</span>
                                              </a>
                                            </li>
                                          )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>

                {allFolderData.length === 0 && (
                  <div className="notfound">
                    <img src="/images/no-data-found/tickets-not-found.png" />
                    <p> No data found</p>
                  </div>
                )}

                <div className="modal fade" id="delete-doc">
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content delete-holiday">
                      <div className="modal-header">
                        <img
                          src="/images/org-img/leave/popup-backimg.png"
                          className="backimg"
                        />
                        <div className="img">
                          <img src="/images/org-img/leave/trash.png" />
                        </div>
                      </div>
                      <div className="modal-body text-center">
                        <strong className="modal-title">Are you sure?</strong>
                        <p>Do you really want to delete this document?</p>
                      </div>
                      <div className="modal-footer m-auto">
                        <button
                          type="button"
                          className="cancelbtn-click"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="deletebtn-click"
                          data-bs-dismiss="modal"
                          onClick={() => deleteDocument(0)}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* =============Delete Confirmation Popup======= */}
                <div className="modal fade" id="delete-doc-confirm">
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content delete-holiday">
                      <div className="modal-header">
                        <img
                          src="/images/org-img/leave/popup-backimg.png"
                          className="backimg"
                        />
                        <div className="img">
                          <img src="/images/org-img/leave/trash.png" />
                        </div>
                      </div>
                      <div className="modal-body text-center">
                        <p>{deleteErrorMessage}</p>
                      </div>
                      <div className="modal-footer m-auto">
                        <button
                          type="button"
                          className="cancelbtn-click"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="deletebtn-click"
                          data-bs-dismiss="modal"
                          onClick={() => deleteDocument(1)}
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ==========Create folder============ */}
                <div
                  className="modal fade "
                  id="CreateFolder"
                  tabIndex="-1"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content p-0">
                      <div className="modal-header">
                        <h5 className="modal-title">Create Folder</h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          onClick={() => setResetKey((k) => k + 1)}
                        ></button>
                      </div>

                      <div className="modal-body">
                        <CreateFolder
                          key={resetKey}
                          onFolderClose={(value) =>
                            closeCreateFolderPopup(value)
                          }
                        ></CreateFolder>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ==========Move folder============ */}
                <div
                  className="modal fade "
                  id="move-doc"
                  tabIndex="-1"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog modal-dialog-centered modal-lg"
                    role="document"
                  >
                    <div className="modal-content ">
                      <div className="modal-header">
                        <h5 className="modal-title">Move to</h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          onClick={() => setDocumentId(0)}
                        ></button>
                      </div>

                      <div className="modal-body">
                        <MoveFolder
                          errorMessage={(value) => {
                            setErrorMessage(value);
                          }}
                          onMoveFolderClose={(value) =>
                            closeMoveFolderPopup(value)
                          }
                          selectedMovedDocumentId={selecteddocumentId}
                          FolderId={0}
                        ></MoveFolder>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ==========Rename folder============ */}
                <div
                  className="modal fade "
                  id="Rename"
                  tabIndex="-1"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                  >
                    <div className="modal-content p-0">
                      <div className="modal-header">
                        <h5 className="modal-title">Rename</h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setRenameFolder([]);
                            setDocName("");
                            setRenameErrorMessage("");
                          }}
                        ></button>
                      </div>

                      <div className="modal-body">
                        <div className="row">
                          <div className="col-md-12 mb-5">
                            <label>
                              Name <i className="inValidError">*</i>
                            </label>
                            <div className="d-flex align-items-center">
                              <input
                                type="text"
                                className="form-control me-1"
                                value={setRenameDocValue()}
                                onChange={(e) => {
                                  setDocName(e.target.value);
                                  setRenameValidation(
                                    e.target.value ? false : true,
                                  );
                                }}
                              />
                              {renameFolder?.DocTypeId !== 101 && (
                                <span>
                                  {renameFolder?.DocName?.slice(
                                    renameFolder?.DocName?.lastIndexOf("."),
                                  )}
                                </span>
                              )}
                            </div>

                            {renameValidation && (
                              <div className="invalid-feedback">
                                Name is required.
                              </div>
                            )}

                            {renameErrorMessage && (
                              <div className="invalid-feedback">
                                {renameErrorMessage}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12">
                            <div className="btns-grp text-end">
                              <button
                                type="button"
                                className="cancelbtn-click"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                  setRenameFolder([]);
                                  setDocName("");
                                  setRenameErrorMessage("");
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                type="button"
                                className="savebtn-click btn-purple rounded"
                                onClick={FolderRename}
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ==========Version History ============ */}

                <div
                  className="modal fade "
                  id="version_history"
                  tabIndex="-1"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog modal-dialog-centered modal-lg"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Version History</h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                        ></button>
                      </div>

                      <div className="modal-body">
                        <div className="row">
                          <div className="col-md-12">
                            <table class="table table-file-info">
                              <thead>
                                <tr>
                                  <th scope="col">No.</th>
                                  <th scope="col">Comment</th>
                                  <th scope="col">FileName</th>
                                  <th scope="col">By</th>
                                  <th scope="col">Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {versionHistoryData?.map((history, index) => (
                                  <tr>
                                    <td>{history?.VersionNumber}</td>
                                    <td>{history?.Comment}</td>
                                    <td>
                                      <a
                                        href={`${history?.DocPath}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {history?.Name}
                                      </a>
                                    </td>
                                    <td>
                                      <img
                                        src={history?.ModifiedProfileImage}
                                        onError={handleImageError}
                                        className="rounded-lg me-2"
                                        width="18"
                                        alt=""
                                      />
                                      {history?.ModifiedByName}
                                    </td>
                                    <td>
                                      {moment(history?.ModifiedDate).format(
                                        "MMM DD YYYY",
                                      )}{" "}
                                      {new Date(
                                        history?.ModifiedDate,
                                      ).toLocaleTimeString([], {
                                        hour: "numeric",
                                        minute: "2-digit",
                                      })}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ===========Audit Logs========= */}
                <div
                  className="modal fade "
                  id="audit_log"
                  tabIndex="-1"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog modal-dialog-centered modal-lg"
                    role="document"
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Audit Logs</h5>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                        ></button>
                      </div>

                      <div className="modal-body">
                        <div className="row">
                          <div className="col-md-12">
                            <table class="table table-file-info">
                              <thead>
                                <tr>
                                  <th scope="col">Comment</th>

                                  <th scope="col">By</th>
                                  <th scope="col">Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {auditLogData?.map((history, index) => (
                                  <tr>
                                    <td>{history?.Comment}</td>

                                    <td>{history?.ModifiedByName}</td>
                                    <td>
                                      {moment(history?.ModifiedDate).format(
                                        "MMM DD YYYY",
                                      )}{" "}
                                      {new Date(
                                        history?.ModifiedDate,
                                      ).toLocaleTimeString([], {
                                        hour: "numeric",
                                        minute: "2-digit",
                                      })}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="modal fade"
                  id="DropErrorMessagePopup"
                  tabIndex="-1"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content p-0">
                      <div className="modal-header">
                        <h5 className="modal-title error-alert">Error Alert</h5>
                        <button
                          type="button"
                          className="btn-close p-0"
                          data-bs-dismiss="modal"
                        ></button>
                      </div>

                      <div className="modal-body text-center">
                        <span className="text-purple">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            fill="currentColor"
                            class="bi bi-file-earmark mb-2"
                            viewBox="0 0 16 16"
                          >
                            <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
                          </svg>
                        </span>
                        <p className="error-message">{dropInFolderError}</p>

                        <div className="text-center d-flex ">
                          {folderData?.type === "file" && (
                            <>
                              <button
                                type="button"
                                className="cancelbtn-click"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                  processDragDrop(
                                    folderData.folder,
                                    folderData.folderId,
                                    1,
                                    true,
                                  );
                                }}
                              >
                                Replace
                              </button>
                            </>
                          )}

                          <button
                            type="button"
                            className="savebtn-click btn-purple rounded"
                            data-bs-dismiss="modal"
                            onClick={() => {
                              processDragDrop(
                                folderData.folder,
                                folderData.folderId,
                                2,
                                true,
                              );
                            }}
                          >
                            Keep Both
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <ErrorMessagePopup
                  errorMessage={errorMessages}
                  onCloseErrorPopup={() => {
                    setErrorMessage("");
                    getFolderData("");
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {Isloading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default DocumentFile;
